import type { RefuelAuthorizationState } from "../../config/refuelAuthorization";
import { NightAiScenarioIcon } from "./NightAiScenarioIcon";
import { NightLargeGlowCardSurface } from "./NightLargeGlowCardSurface";
import "./NightCards.css";

interface NightRefuelAuthorizationCardProps {
  session: RefuelAuthorizationState;
  onAuthorize: () => void;
  onDismiss: () => void;
}

export function NightRefuelAuthorizationCard({
  session,
  onAuthorize,
  onDismiss
}: NightRefuelAuthorizationCardProps) {
  if (session.stage === "idle") {
    return null;
  }

  if (session.stage === "authorized") {
    const authorizationDigits = session.authorizationCode.split("");

    return (
      <section
        className="night-ai-expanded-card night-ai-expanded-card--large night-ai-expanded-card--auth-code night-refuel-authorization-card night-refuel-authorization-card--authorized"
        aria-label="加油授权码"
      >
        <NightLargeGlowCardSurface />
        <span className="night-ai-expanded-card__content-mask" aria-hidden="true" />
        <div className="night-ai-scenario-icon night-ai-scenario-icon--fuel night-ai-expanded-card__icon">
          <NightAiScenarioIcon icon="fuel" />
        </div>
        <div className="night-ai-expanded-card__main">
          <h2>加油授权码</h2>
          <p>{session.stationName} · {session.gradeLabel} · {session.amountLabel}</p>
        </div>
        <div className="night-ai-expanded-card__auth-code" aria-label={`加油授权码 ${session.authorizationCode}`}>
          {authorizationDigits.map((digit, index) => (
            <span className="night-ai-expanded-card__auth-digit" key={`${digit}-${index}`}>
              <span>{digit}</span>
            </span>
          ))}
        </div>
        <div className="night-ai-expanded-card__actions">
          <button type="button" className="night-ai-expanded-card__action night-ai-expanded-card__action--primary" onClick={onDismiss}>
            完成
          </button>
          <button type="button" className="night-ai-expanded-card__action night-ai-expanded-card__action--secondary" onClick={onDismiss}>
            收起
          </button>
        </div>
      </section>
    );
  }

  return (
    <section className="night-ai-expanded-card night-refuel-authorization-card night-refuel-authorization-card--arrived" aria-label="已到达加油站">
      <span className="night-ai-expanded-card__surface" aria-hidden="true" />
      <span className="night-ai-expanded-card__content-mask" aria-hidden="true" />
      <span className="night-ai-scenario-icon night-ai-scenario-icon--fuel night-ai-expanded-card__icon">
        <NightAiScenarioIcon icon="fuel" />
      </span>

      <div className="night-ai-expanded-card__main">
        <h2>已到达加油站</h2>
        <p>已到达{session.stationName}，可生成站内核销授权码。</p>
      </div>

      <div className="night-refuel-authorization-card__status" aria-label="加油授权摘要">
        <span className="night-refuel-authorization-card__status-dot" aria-hidden="true" />
        <span>
          <strong>{session.gradeLabel} · {session.amountLabel}</strong>
          <small>{session.priceLabel} · {session.couponLabel} · 排队{session.queueMinutes}分钟</small>
        </span>
      </div>

      <div className="night-ai-expanded-card__actions">
        <button
          type="button"
          className="night-ai-expanded-card__action night-ai-expanded-card__action--primary"
          onClick={onAuthorize}
        >
          生成授权码
        </button>
        <button
          type="button"
          className="night-ai-expanded-card__action night-ai-expanded-card__action--secondary"
          onClick={onDismiss}
        >
          稍后
        </button>
      </div>
    </section>
  );
}
